import { COOKIES } from 'common/domain/constants';

class ModalsBehaviourService {

  constructor($cookies) {
    'ngInject';
    this.cookies = $cookies;
    this.reset();
  }

  reset() {
    this.warnLastDayShouldBeVisible = false;
    this.coachmarkModalDismissed = false;
    this.coachmarkHasBeenSeen = this.userHasSeenCoachmark();
  }

  userHasSeenCoachmark() {
    return this.cookies && this.cookies.get(COOKIES.COACHMARK);
  }

  warLastDayShouldBeVisibleAndWarnModalHasBeenDisplayed() {
    if (this.warnLastDayShouldBeVisible) {
      return process.isWarnModalBeenDisplayed;
    }

    return !this.warnLastDayShouldBeVisible;
  }

  isDelegationVisibleWhenCoachmarkHasBeenSeen() {
    if (!this.coachmarkHasBeenSeen) {
      return false;
    }

    return this.warLastDayShouldBeVisibleAndWarnModalHasBeenDisplayed();
  }

  isDelegationVisibleWhenCoachmarkHasBeenDismissed() {
    if (!this.coachmarkModalDismissed) {
      return false;
    }

    return this.warLastDayShouldBeVisibleAndWarnModalHasBeenDisplayed();
  }

  delegationIsVisible() {
    return this.isDelegationVisibleWhenCoachmarkHasBeenSeen() || this.isDelegationVisibleWhenCoachmarkHasBeenDismissed();
  }

}

export default ModalsBehaviourService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/services/modalsBehaviour.service.js